import * as types from "../constants/actionTypes";
import * as txt from "../constants/textConstants";
import * as msgs from "../constants/textConstants";
import * as features from "../constants/MembershipFeatures";
import Cookies from "cookies-js";
import { getDomain } from "../helpers/Tools";
import * as Tools from "../helpers/Tools";
import uuidv4 from "uuid/v4";


// IMPORTANT!!! -->> do not forget to add any fields in this model to the serverside model, otherwise the properties are stripped on serverside render
export function domainInitialState()
{
    var dLastReduced = new Date();
    dLastReduced.setDate(dLastReduced.getDate() - 1);

    //debugger;
    var oRet = 
    {
        ds: null, // ds = Date saved
        li: false, // li = logged In
        lom: null, // lom = log out message
        hm: false, // hm = has MyChart
        ru: null, // ru = redirect URL
        //hp: false, // hp = has Pharmacy   ***DEPRECATED
        hh: false, // hh = has HealthPlan
        rt: null, // rt = refresh token
        un: null, // un = healthsource UserName
        mc: null, // mc = MyChart ID
        amc: null, //amc = auto MyChart ID
        ei: null, // ei = Employee ID
        hi: null, // hi = HealthPlan ID
        ls: null, // ls = login status
        t: null, // t = token
        cu: null, // cu = current user
        pu: null, // pu = primary user
        pl: null, // pl = proxy list
        nc: null, // nc = networkcode
        e: null, // e = email, 
        eid: null, // eid = EPID (from HealthSource API), 
        tk: null, // tk = token key
        ct: false, // ct = Can access thrive
        ie: false, // ie = is employee
        cpu: null, // cpu = current pharmacy user
        dto: null, // dto = datetime offset (gathered initially on the client and then passsed up to the server to make time adjustments on postbacks),
        ip: false, // ip = Is Proxy
        z: null, // z = zipc ode
        c: Cookies.get("bsw-CorrelationId") || uuidv4(),  //c = correlationId
        s: Cookies.get("bsw-SessionId") || uuidv4(), // s = sessionId
        fc: false, // Flu Consent
        ui: null,  // ui = HealthSource UserID (guid)
        mq: false,  // mq = Mobile per query string
        sb: false, // show custom graphics banner
        aal: false, // aal = has AAL
        aaal: false, //aaal = auto-aal
        lt: null, // latitude
        ln: null,  // longitude
        aaai: null, // AA auto ID
        aai: null,  // AA actual ID
        age: null,
        qp: null, // Redirect query params
        ix: false, //user has role Xealth_Member
        cm: null, //current proxy managers
        hri: null, // HealthRulesID
        hhri: false,  // Has HealthRulesID
        hpid: null, // HCID (new healthplan username for Austin user database)
        l: null, // logins
        pre: null, // Health Plan Prefix
        hpp: false, // hpp is user payer
        sx: false,  // show pharmacy
        lr: dLastReduced // last reduced,
    };
    //debugger;
    return oRet;
};

export const proxyListUser = {
    dn: null, // displayName
    ei: null, // externalId
    ii: null, // internalId
    mi: null, // myChartId
    eid: null, // eid
    ri: null, // relationshipId
    i: -1, // index
    ay: null, // age years
    dob: null, // birthDate
    im: false, // isMinor
    epi: null, //epi
    ed: null  //expire to-date
};


export const pharmacyProxyUser = {
    fn: null, // first name
    ln: null, // last name
    id: null, // pharmacy patient id
    i: null // index
};

// IMPORTANT!!! -->> do not forget to add any fields in this model to the serverside model, otherwise the properties are stripped on serverside render

export function compressProxyUser(pu) {
    if (pu && pu.displayName) {   
        return {
            dn: pu.displayName,
            ei: pu.externalId,
            ii: pu.internalId ? pu.internalId.trim() : null,
            mi: pu.myChartId + "",
            eid: pu.eid,
            ri: pu.relationshipId,
            i: pu.index,
            ay: pu.ageYears,
            dob: pu.dob,
            im: pu.isMinor,
            epi: pu.epi,
            ed: pu.expireDate ? pu.expireDate : null
        };
    }
    return null;
}

export function hydrateProxyUser(cu) {
    if (cu && cu.dn) {   
        return {
            displayName: cu.dn,
            externalId: cu.ei,
            internalId: cu.ii,
            myChartId: cu.mi + "",
            eid: cu.eid,
            relationshipId: cu.ri,
            index: cu.i,
            ageYears: cu.ay,
            dob: cu.dob,
            isMinor: cu.im,
            epi: cu.epi,
            ed: cu.ed
        };
    }
    return null;
}

export function compressPharmacyUser(pu) {
    if (pu && pu.pharmacyPatientId) {
        return {
            fn: pu.firstName,
            ln: pu.lastName,
            id: pu.pharmacyPatientId,
            i: pu.index
        };
    }
}

export function hydratePharmacyUser(cu) {
    if (cu && cu.id) {
        return {
            firstName: cu.fn,
            lastName: cu.ln,
            pharmacyPatientId: cu.id,
            index: cu.i
        };
    }
}



export default function domainReducer(state = domainInitialState(), action) {
    var myDomain = getDomain();
    var oRet;
    const isServerSide = typeof window === "undefined";
    switch (action.type) {
        case types.UPDATE_TOKEN_AND_REFRESH_TOKEN:
            //debugger;
            if (action.isLoggedIn) {
                //debugger;
            }
            return {
                ...state,
                t: action.token,
                rt: action.refreshToken,
                li: action.isLoggedIn
            };

        case types.LOGIN_FORM_SUCCESS:
            oRet = {
                ...state,
                lr: new Date(),
                s: uuidv4()
            };
            //debugger;
            Cookies.set("bsw-SessionId", oRet.s, { path: '/', domain: myDomain });
            return oRet;

        case types.LOGIN:
            return {
                ...state,
                lr: new Date(),
                //s: uuidv4()
            };

        case types.CLEAR_USERLOGGEDOUT_MESSAGE:
            var sNewMessage = state.lom;
            if (sNewMessage === msgs.UserInitiatedLogoutMessage) {
                sNewMessage = null;
            }
            return {
                ...state,
                lr: new Date(),
                lom: sNewMessage
            };

        case types.LOGOUT_COMPLETED:
            //debugger;
            if (typeof window !== "undefined") {
                try { window.appInsights.clearAuthenticatedUserContext(); } catch (e) { }
            }
            //Cookies.set('authToken', "", { path: '/', domain: myDomain });
            //Cookies.set('refreshToken', "", { path: '/', domain: myDomain });
            if (typeof window !== "undefined") {
                window.currentUserName = null;
            }
            return {
                //...state,
                ...domainInitialState(),
                lr: new Date(),
                lom: state.lom,
                ru: action.DontClearRedirectURL ? state.ru : null,
            };
        case types.SET_HP_PREFIX:
            return {
                ...state,
                pre: action.prefix,
                lr: new Date()
            };
        case types.USER_LOGGED_OUT:
            //debugger;
            if (typeof window !== "undefined") {
                try { window.appInsights.clearAuthenticatedUserContext(); } catch (e) { }

            }
            let oLogoutState = {
                ...state,
                lom: action.logoutMessage || state.lom,
                ru: action.DontClearRedirectURL ? state.ru : null,
                s: uuidv4(),
                lr: new Date()
            };
            //debugger;
            Cookies.set("bsw-SessionId", oLogoutState.s, { path: '/', domain: myDomain });
            return oLogoutState;

        case types.GRAPHIC_BANNER_UPDATE:
            return {
                ...state,
                sb: false,
                lr: new Date()
            };

        case types.MEMBERSHIP_GET_SUCCESS:
            try {
                var profileList = Tools.getProfileListFromMembershipData(action.data);

                var Proxies = [];
                // Overwrite existing proxy list
                var newProxyList = Tools.convertProfileListToProxyList(profileList);

                var currPrimUser = state.pu ? hydrateProxyUser(state.pu) : newProxyList[ 0];  // preserve current primary and add missing values (then replace in the array)

                newProxyList.forEach((c, index, arr) => {

                    if (currPrimUser) {
                        //debugger;
                        if (currPrimUser.myChartId && c.myChartId && currPrimUser.myChartId.toUpperCase() === c.myChartId.toUpperCase()) {
                            //debugger;
                            currPrimUser.externalId = c.externalId;
                            currPrimUser.internalId = c.internalId;
                            currPrimUser.eid = c.eid;
                            currPrimUser.myChartId = c.myChartId; // this corrects the casing differences
                            currPrimUser.relationshipId = c.relationshipId;
                            currPrimUser.eVisit = c.eVisit;
                            currPrimUser.ageYears = c.ageYears;
                            currPrimUser.dob = c.dob;
                            currPrimUser.isMinor = c.isMinor;
                            currPrimUser.epi = c.epi;
                            c = currPrimUser;
                        }
                    }
                    Proxies.push(compressProxyUser(c));
                });
                var currCurrentUser = hydrateProxyUser(state.cu);
                if (!currCurrentUser) {
                    currCurrentUser = currPrimUser;
                }

                //debugger;

                return {
                    ...state,
                    pl: Proxies,
                    pu: compressProxyUser(currPrimUser),
                    cu: compressProxyUser(currCurrentUser),
                    hm: Tools.hasMyChart(action.data),
                    mc: Tools.getMyChartID(action.data),
                    //hp: Tools.hasFeature(action.data, features.RXModule) && Tools.getFeature(action.data, features.RXModule).active, // DEPRECATED
                    sx: Tools.hasFeature(action.data, features.RXModule),
                    lr: new Date()
                };

            }
            catch (ex) {
                console.error(ex);
                //debugger;
                throw ex;
            }

        case types.USER_AUTHENTICATE_FAILURE:
            if (typeof window !== "undefined") {
                try { window.appInsights.clearAuthenticatedUserContext(); } catch (e) { }
            }
            return {
                ...state,
                ls: action.type,
                lr: new Date()
            };

        case types.USER_AUTHENTICATE:
            return {
                ...state,
                lom: null,
                ls: action.type,
                //s: uuidv4(),
                lr: new Date()
            };
        case types.USER_AUTHENTICATE_ISLOGGEDIN:
            if (action.userData && action.userData.access_token)
            {
                //debugger;
            }
            return {
                ...state,
                li: action.userData && action.userData.access_token ? true : false,
                lr: new Date()
            };
        case types.USER_AUTHENTICATE_SUCCESS:
            //debugger;
            const userData = action.userData;
            const displayName = (userData.Givenname || userData.GivenName) + ' ' + userData.Surname;
            const epid = userData.EPID;
            const mychart = userData.MyChartID;
            //Cookies.set('authToken', action.userData.access_token, { path: '/', domain: myDomain });
            //Cookies.set('refreshToken', action.userData.refresh_token, { path: '/', domain: myDomain });
            if (typeof window !== "undefined") {
                window.currentUserName = action.userData.userName; // we write this down here so anyone anywhere in any javascript can grab the value and run with it
                if (window.appInsights) {
                    try {
                        window.appInsights.setAuthenticatedUserContext(window.currentUserName);
                    }
                    catch (eee) {
                        console.error(eee);
                    }
                }

            }

            // Parse Consents
            var bFluConsent = false;
            var sConsents = userData.Consents;
            if (sConsents) {
                var sParts = sConsents.split(";");
                for (var i = 0; i < sParts.length; i++) {
                    if (sParts[i] !== "") {
                        var sParts2 = sParts[i].split("=");
                        if (sParts2.length > 1) {
                            if (sParts2[0] === window.serverData.data.currentFluKey) {
                                bFluConsent = (sParts2[1] === "1");
                                break;
                            }
                        }
                    }
                }
            }
             
            //debugger;
            oRet = {
                ...state,
                t: action.userData.access_token,
                rt: action.userData.refresh_token,
                hm: action.userData.Logins && action.userData.Logins.toLowerCase().indexOf("mychart") !== -1,  // moved to memberships
                //hp: action.userData.Logins && action.userData.Logins.toLowerCase().indexOf("pharmacy") !== -1 , //DEPRECATED
                hh: action.userData.Logins ? action.userData.Logins.toLowerCase().indexOf("healthplan") !== -1 : false,
                ls: action.type,
                pu: compressProxyUser({ displayName: displayName, epid: epid, myChartId: (mychart ? mychart : "") }),
                un: action.userData.userName,
                mc: state.mc,
                ei: action.userData.EmpID,
                hi: action.userData.HealthPlanID,
                nc: action.userData.HealthPlanNetworkCode,
                e: action.userData.Email,
                eid: action.userData.EPID,
                tk: action.userData.TokenKey,
                z: action.userData.Zipcode,
                fc: bFluConsent,
                ie: action.userData.EmpID !== null && action.userData.EmpID !== "",
                ui: action.userData.Id,
                aal: action.userData.Logins ? action.userData.Logins.split(",").map(item => item.toLowerCase()).indexOf('aal') !== -1 : false,
                aaal: action.userData.Logins ? action.userData.Logins.split(",").map(item => item.toLowerCase()).indexOf('auto-aal') !== -1 : false,
                aaai: action.userData.AUTO_AAL,
                aai: action.userData.AAL,
                hri: action.userData.HealthRulesID,
                sb: true,
                age: action.userData.Age,
                amc: action.userData.AUTO_MyChartID ? action.userData.AUTO_MyChartID : null,
                ix: action.userData.Roles ? action.userData.Roles.toLowerCase().indexOf("xealth_member") !== -1 : false,
                hhri: action.userData.HealthRulesID !== null && action.userData.HealthRulesID !== "",
                hpid: action.userData.hpUserIdentity,
                l: action.userData.Logins,
                lr: new Date()
                //s: uuidv4()
            };
            //debugger;
            //Cookies.set("bsw-SessionId", oRet.s, { path: '/', domain: myDomain });
            return oRet;

        case types.HP_AMI_ISUSERPAYER_SUCCESS:
            return {
                ...state,
                hpp: action.isUserPayer,
                lr: new Date()
            };

        case types.HP_USERDATA_SUCCESS:
            return {
                ...state,
                hpid: action.hpUserIdentity.username,
                lr: new Date()
            };

        case types.SET_REDIRECT_URL:
            // at no point do we want the redirect url to become either login or acceptterms
            //debugger;
            let newURL = state.ru;
            let passedURL = action.URL;
            let params = '';
            if (action.params) {
                params = action.params;
            }
            if (passedURL && passedURL !== "/login" && passedURL !== "/onboarding/acceptterms") {
                newURL = passedURL;
            }
            window.redirectURL = newURL;
            return {
                ...state,
                ru: newURL,
                qp: params,
                lr: new Date()
            };

        case types.CLEAR_REDIRECT_URL:
            //debugger;
            window.redirectURL = null;
            return {
                ...state,
                ru: null,
                qp: null,
                lr: new Date()
            };

        case types.SWITCH_USER_REDUCER:
            let au = action.user;
            let isProxyUser = !Tools.usersAreTheSame(hydrateProxyUser(state.pu), au);
            return {
                ...state,
                cu: compressProxyUser(au),
                ip: isProxyUser,
                lr: new Date()
            };

        case types.SWITCH_TO_PHARMACY_USER:
            return {
                ...state,
                cpu: compressPharmacyUser(action.pharmacyUser),
                lr: new Date()
            };

        case types.THRIVE:
            return {
                ...state,
                ct: action.thrive.canVisitThrive,
                //ie: action.thrive.employeeLoggedIn,
                lr: new Date()
            };

        case types.GEOLOCATION_SUCCESS:
            return {
                ...state,
                lt: action.latitude,
                ln: action.longitude,
                lr: new Date()
            };
        case types.COOKIE_BSWPROXY_START:
            return {
                ...state,
                bswProxySwithcing: true,
                lr: new Date()
            };
        case types.COOKIE_BSWPROXY_SUCCESS:
            return {
                ...state,
                bswProxySwithcing: false,
                lr: new Date()
            };
        case types.LOAD_CURRENT_MANAGERS_SUCCESS:
            {
                const currManagerList = [];
                action.currManagerList.forEach((c, index, arr) => {
                    currManagerList.push(compressProxyUser(c));
                });   
                
                return {
                    ...state,
                    cm: currManagerList,
                    managerListFailure: false,
                    lr: new Date()
                };
            }
        case types.LOAD_CURRENT_MANAGERS_FAILURE:
            return {
                ...state,
                cm: [],
                managerListFailure: true,
                lr: new Date()
            };
        default:
            let c = state.c;
            if (c === null) {
                //debugger;
                c = uuidv4();
            }
            return {
                ...state,
                dto: isServerSide ? state.dto : new Date().getTimezoneOffset(),
                c: c,
                lr: new Date()
            };

    }
}